import { CTA_MODE, appHref, waLink } from "@/config";
import { scrollToLeadForm } from "@/lib/scroll";
import { MessageCircle } from "lucide-react";

// side: "renter" | "host"
export const CtaButton = ({ side, children, variant = "primary", testId, className = "" }) => {
  const cls = variant === "primary" ? "nb-btn-primary" : "nb-btn-ghost";
  if (CTA_MODE === "app") {
    return (
      <a
        data-testid={testId}
        href={appHref(side)}
        className={`${cls} ${className}`}
        onClick={() => window.dispatchEvent(new CustomEvent("nb:cta", { detail: side }))}
      >
        {children}
      </a>
    );
  }
  return (
    <button
      data-testid={testId}
      type="button"
      className={`${cls} ${className}`}
      onClick={() => scrollToLeadForm(side === "host" ? "have_spot" : "need_spot")}
    >
      {children}
    </button>
  );
};

export const WhatsAppButton = ({ kind = "general", label = "WhatsApp us", testId, className = "" }) => (
  <a
    data-testid={testId}
    href={waLink(kind)}
    target="_blank"
    rel="noopener"
    className={`nb-btn-ghost ${className}`}
  >
    <MessageCircle size={17} aria-hidden="true" />
    {label}
  </a>
);
